import { ErrorType } from '@dgx-pr-spa/shared/util';
import { DeliveryDates } from '@dgx-pr-spa/shared/util';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'earliestDeliveryDateText',
})
export class EarliestDeliveryDateTextPipe implements PipeTransform {
  errorType = ErrorType;

  /**
   * Selects earliest date from array
   */
  filterEarliestDate(dates: string[]) {
    return dates.reduce((pre, cur) => {
      return Date.parse(pre) > Date.parse(cur) ? cur : pre;
    });
  }

  /**
   * Returns natural language date
   */
  transformOrdinalDate(value: Date): string {
    if (!value) {
      return '';
    }
    const months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    return `${value.getDate()}${this.nth(value.getDate())} ${
      months[value.getMonth()]
    }`;
  }

  nth(d) {
    if (d > 3 && d < 21) return 'th';
    switch (d % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  }

  transform(dates: DeliveryDates): string {
    if (dates.delivery_dates && dates.delivery_dates.length) {
      const earliest = this.filterEarliestDate(dates.delivery_dates);
      const ordinalDate = this.transformOrdinalDate(new Date(earliest));
      return `From ${ordinalDate}`;
    } else {
      return '';
    }
  }
}
